import React from 'react';
import { motion } from 'framer-motion';
import { Eye } from 'lucide-react'; // Cambiado a icono de ojo

const CourseCard = ({ course, onDetailsClick }) => {
  return (
    <motion.div
      className="bg-white/90 backdrop-blur-sm border border-gray-200/50 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col justify-between"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      whileHover={{ scale: 1.02, borderColor: 'rgba(251, 146, 60, 0.8)' }}
    >
      <div>
        <h3 className="text-2xl font-extrabold text-gray-900 mb-2 bg-gradient-to-r from-orange-500 to-amber-600 bg-clip-text text-transparent">
          {course.name}
        </h3>
        <p className="text-gray-600 text-sm mb-4 line-clamp-3">
          {course.description}
        </p>
      </div>
      <div className="flex justify-end">
        <motion.button
          onClick={() => onDetailsClick(course)}
          className="p-3 bg-gradient-to-r from-orange-500 to-amber-600 text-white rounded-full shadow-md hover:shadow-lg transition-all duration-300"
          whileHover={{ scale: 1.1, backgroundColor: 'rgba(251, 146, 60, 1)' }}
          whileTap={{ scale: 0.9 }}
          title="Ver más información"
        >
          <Eye className="w-6 h-6" /> {/* Icono de ojo */}
        </motion.button>
      </div>
    </motion.div>
  );
};

export default CourseCard;